import React from 'react';
import { Form, Input, Button, Card, message, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import './Login.css';

export default function Login({ setUser }) {
  const [loading, setLoading] = React.useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post('/api/auth/login', {
        username: values.username,
        password: values.password
      });

      const { user, token } = response.data;
      
      // Guardar en localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      message.success('¡Bienvenido!');
      setUser(user);
    } catch (error) {
      message.error('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" style={{ width: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ fontSize: '28px', marginBottom: '10px' }}>
            🌐 ESP32 Platform
          </h1>
          <p style={{ color: '#666' }}>Sistema de Monitoreo y Control</p>
        </div>

        <Form
          name="login"
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Ingresa tu usuario' }]}
          >
            <Input
              placeholder="Usuario"
              prefix={<UserOutlined />}
              size="large"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Ingresa tu contraseña' }]}
          >
            <Input.Password
              placeholder="Contraseña"
              prefix={<LockOutlined />}
              size="large"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Recuérdame</Checkbox>
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
          >
            Iniciar Sesión
          </Button>
        </Form>

        <div style={{ textAlign: 'center', marginTop: '20px', color: '#666' }}>
        </div>
      </Card>
    </div>
  );
}
